export const ASSOCIATIONS_PAGE = {
  title: "Les associations de la commune",
  eyebrow: "Vie associative",
  description:
    "Retrouvez les associations locales, leurs contacts, leurs activités et leur localisation lorsque l’adresse est renseignée.",
  heroImageUrl:
    "https://www.mairie-bruges.fr/media/cache/1600x400/uploads/page/5c0529de0cd4a582931665.jpg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Associations" },
  ],
};

export const ASSOCIATIONS_FILTER_LABELS = {
  searchPlaceholder: "Exemple : judo, musique, solidarité, sport…",
};